import commarize from './commarize'
import pluralize from './pluralize'
import dateFormat from './dateFormat'
import fileSize from './fileSize'
import fileName from './fileName'
import splitUpperCase from './splitUpperCase'
import numberSeparator from './numberSeparator'
import http from './http'
import dateFormatWithHours from './dateFormatWithHours'

export default function (Vue) {
  Vue.filter('commarize', commarize)
  Vue.filter('pluralize', pluralize)
  Vue.filter('dateFormat', dateFormat)
  Vue.filter('dateFormatWithHours', dateFormatWithHours)
  Vue.filter('fileSize', fileSize)
  Vue.filter('fileName', fileName)
  Vue.filter('splitUpperCase', splitUpperCase)
  Vue.filter('numberSeparator', numberSeparator)
  Vue.filter('http', http)
}
